import styled, { breakpoints } from '../../../styles/theme';
import HeaderStyled from '../HeaderStyled';
import { rem } from 'polished';

export const HeaderStyledAP = styled(HeaderStyled)`
    background: black;
    height: ${rem(60)};
    display: flex;
    align-items: center;
    padding: ${rem(5)};

    @media (min-width: ${breakpoints.md}px) {
        padding: ${rem(20)};
        height: ${rem(100)};
    }

    .accountStatement {
        svg {
            width: ${rem(20)};
        }
    }

    .main-section {
        align-items: center;
    }

    .header-container {
        a {
            &:focus-visible {
                outline-color: ${({ theme }) => theme.colors.white} !important;
            }
        }

        .title-section {
            border: none;
            margin-left: 0;
            padding: 0 ${rem(5)};

            @media (min-width: ${breakpoints.md}px) {
                padding: 0 ${rem(25)};
            }

            .title-primary {
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                letter-spacing: 0.008em;

                @media (min-width: ${breakpoints.md}px) {
                    font-size: ${({ theme }) => theme.fontSizes.textSupMedium};
                    line-height: ${({ theme }) => theme.lineHeights.textSupMedium};
                }
            }
        }

        .title-secondary {
            font-size: ${rem('9px')};
            margin: 0;

            @media (min-width: ${breakpoints.md}px) {
                font-size: ${({ theme }) => theme.fontSizes.textSmall};
                display: block;
            }
        }

        .navigation {
            button {
                &:focus-visible {
                    outline-color: ${({ theme }) => theme.colors.white} !important;
                }
            }
            margin-bottom: unset;

            @media (min-width: ${breakpoints.md}px) {
                margin-bottom: auto;
            }

            a {
                height: auto;

                p {
                    font-size: ${({ theme }) => theme.fontSizes.textBase};
                    text-transform: unset;
                    white-space: normal;
                }

                @media (min-width: ${breakpoints.md}px) {
                    flex-direction: row;
                }
            }

            .need-help-link__chevron {
                svg {
                    path {
                        stroke: ${({ theme }) => theme.colors.white};
                    }
                }
                &.isOpen {
                    svg {
                        path {
                            stroke: ${({ theme }) => theme.colors.black};
                        }
                    }
                }
            }

            .need-help-section__link {
                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.primary} !important;
                    }
                }
            }

            .header__nav-description_secondary {
                color: ${({ theme }) => theme.colors.primary};
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
            }

            .storeCar,
            .account {
                svg {
                    margin-top: 0.3rem;
                    margin-right: 0.6rem;
                    width: ${rem('17px')};
                    height: ${rem('17px')};
                }

                path {
                    fill: ${({ theme }) => theme.colors.white};
                }
            }

            .basket {
                svg {
                    margin-top: 0.3rem;
                    margin-right: 0.6rem;
                    height: ${rem('17px')};
                    width: ${rem('17px')};
                }

                @media (min-width: ${breakpoints.sm}px) {
                    margin-left: 0.5rem;
                }
            }

            .logoutBox {
                right: ${rem(50)};

                svg {
                    width: ${rem(15)};
                    height: ${rem(20)};
                    margin-right: 5px;

                    g {
                        path {
                            stroke: ${({ theme }) => theme.colors.primaryBlack};
                            fill: ${({ theme }) => theme.colors.primaryBlack};
                        }
                    }
                }

                .accountStatement {
                    border-color: ${({ theme }) => theme.colors.grey7};

                    p {
                        font-size: ${({ theme }) => theme.fontSizes.textBase};
                        margin: 0 0 0 ${rem(5)};
                        text-transform: unset;
                    }
                }

                .logoutButton {
                    border: none;
                    justify-content: left;

                    &Text {
                        margin-left: ${rem(5)};
                    }

                    &Icon {
                        svg {
                            padding-top: ${rem(5)};
                        }
                    }

                    &:hover {
                        background: ${({ theme }) => theme.colors.white};

                        span {
                            color: ${({ theme }) => theme.colors.primaryBlack};
                        }
                    }
                }
            }

            .pxAttention {
                margin: 0 0.5rem;
            }
        }

        .header {
            &__nav-description {
                display: none;
                font-size: ${({ theme }) => theme.fontSizes.textTiny} !important;
                font-weight: ${({ theme }) => theme.fontWeights.textRegular};
                text-transform: uppercase !important;

                @media (min-width: ${breakpoints.md}px) {
                    display: block;
                }
            }
        }
    }

    .logo {
        &:focus-visible {
            outline-color: ${({ theme }) => theme.colors.white} !important;
        }

        .icon-wrapper {
            @media (max-width: ${breakpoints.md}px) {
                height: ${rem(40)};

                svg {
                    height: ${rem(40)};
                }
            }
        }
    }

    .icon-wrapper {
        margin: 0;
    }
`;
